
//console.log("calling notify-me");

let loaded = false;
let isModalRegistered = false;
document.addEventListener("DOMContentLoaded", function () {
	if (!loaded) {
		console.log("DOMContentLoaded | addMutationObserver");

		const formProduct = document.querySelector(".ProductForm");
		const notifyModal = document.querySelector("body");

		addMutationObserver(formProduct, triggerNotify);
		// addMutationObserver(notifyModal, registerDataLayer);

		loaded = true;
		document.querySelector(".NotifyMe__desk").addEventListener("click", function () {
			sendDataLayerOpen();
		});

		window.addEventListener("resize", (e) => {
			let Notify = document.querySelector(".restock-alerts-notify-button");
			if (Notify) {
				setButtonPosition(Notify);
			}
		});
	}
});

const sendDataLayerOpen = () => {
	dataLayer.push({
		event: "select_content",
		content_type: "notify_me",
		item_id: "open",
	});
};
const sendDataLayerSubmit = () => {
	dataLayer.push({
		event: "select_content",
		content_type: "notify_me",
		item_id: "submit",
	});
};


isNotifyReady = false;

function addMutationObserver(selector, customCallback) {
	// console.log("Observer | addMutationObserver added");
	let targetNode = selector;
	if (targetNode) {
		// console.log("Observer | target on node");
		let config = { attributes: true, childList: true, subtree: true };
		const callback = function (mutationsList, observer) {
			// console.log("Observer | callback called");
			// isNotifyReady = false;
			// Use traditional 'for loops' for IE 11
			for (const mutation of mutationsList) {
				if (mutation.type === "childList") {
					if (isNotifyReady == false) {
						customCallback();
					}
				} else if (mutation.type === "attributes") {
				}
			}
		};

		let observer = null;
		observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}
}

function triggerNotify() {
	//console.log("***TRIGGER***");
	const NotifyMe = document.querySelector(".restock-alerts-notify-button");
	var $closeCTAMobileSizeModal = $(".close-mobile-size-modal");
	// console.log(document.querySelector(".restockify-notify-button"));
	// console.log(document.querySelector(".bestpush-bis-notify-status"));


	if (NotifyMe != null) {
		NotifyMe.classList.remove("Button--primary");
		NotifyMe.style.backgroundColor = "#c0b9b5";

		setButtonPosition(NotifyMe);

		$closeCTAMobileSizeModal.on("click", function () {
			NotifyMe.style.display = "none";
		});

	}
}

function registerDataLayer() {
	const modal = document.querySelector(".restock-alerts-modal-wrapper");
	if (modal) {
		if (!isModalRegistered) {
			// modal.addEventListener("click", function () {
			// 	sendDataLayerSubmit();
			// });
			isModalRegistered = true;
		}
	} else {
		isModalRegistered = false;
	}
}

function setButtonPosition(btn) {
	const bottone = btn;
	const BtnAddCart = document.getElementById("btn-add-to-cart");
	const targetRect = BtnAddCart.getBoundingClientRect();
	const wWidth = window.innerWidth;

	let finishTop = targetRect.top - (targetRect.height * 2 + 6);

	if (wWidth > 1023) {
		bottone.style.top = finishTop + "px";
	} else {
		bottone.style.top = "unset";
		bottone.style.bottom = "6px";
	}
}
